// extracted by mini-css-extract-plugin
export var lModalMenu__list__item = "Xe";
export var aTitle1 = "Ye";
export var lModalMenuBg = "Ze";
export var lModalMenuButton = "_e";
export var lModalMenu = "af";
export var lModalMenu__inner = "bf";
export var lModalMenu__list = "cf";
export var aInner = "df";
export var aTitle2 = "ef";
export var lModalMenu__list2 = "ff";
export var lModalMenu__footer = "gf";
export var lModalMenu__footer__menu = "hf";
export var lModalMenu__footer__copyright = "if";
export var animationMarquee = "jf";